import { render, staticRenderFns } from "./TitleListGrid.vue?vue&type=template&id=bcf8bf46"
import script from "./TitleListGrid.vue?vue&type=script&setup=true&lang=ts"
export * from "./TitleListGrid.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TitleListGrid.vue?vue&type=style&index=0&id=bcf8bf46&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports